<template>
  <ItemPage
    title="Usuários"
    size="sm"
    :actions="actions"
  >
    <v-container v-if="intranetUserView">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisa"
            single-line
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
    <v-simple-table
      v-if="intranetUserView"
      fixed-header
    >
      <template v-if="loading">
        <Load :loading-msg="loadingMsg" />
      </template>
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="users"
          :items-per-page="15"
          :search="search"
          item-key="id"
          @click:row="editUser($event)"
        >
          <template #item.status="{ item }">
            {{ statusText(item.status) }}
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import NewUserDialog from '@/components/UsersAndRoles/NewUserDialog.vue'
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load, ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      intranetUserView: true,
      intranetUserCreate: true,
      loading: false,
      loadingSave: false,
      loadingMsg: '',
      loadingSaveMsg: '',
      users: [],
      status: '',
      msg: '',
      updateUser: false,
      dialogAddUser: false,
      idUser: undefined,
      renderComponent: 0,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'E-mail',
          align: 'start',
          value: 'email'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        }
      ]
    }
  },

  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Usuário',
          action: this.openNewUserDialog,
          icon: 'mdi-plus',
          disabled: !this.intranetUserCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.intranetUserView = utils.checkPermissions('intranet-users.view-any')
      this.intranetUserCreate = utils.checkPermissions('intranet-users.create')
      this.getUsers()
    },
    async getUsers () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const users = await this.$api.getUser()
        this.users = users
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os usuários, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editUser (event) {
      this.$router.push({ name: 'usuarios.id', params: { id: event.id } })
    },
    statusText (typevalue) {
      const status = this.$api.statusType()
      return status.find(element => element.value === typevalue).statusName
    },

    openNewUserDialog () {
      this.$dialog.custom(NewUserDialog).show()
        .then((newUser) => {
          if (!newUser) {
            return
          }
          this.$router.push({ name: 'usuarios.id', params: { id: newUser.id } })
        })
    }
  }
}
</script>
